import PersonalInfoPageContent from '@/components/PersonalInfoPageContent';
import useProfile from '@/hooks/useProfileV2';

const HomePersonalInfo = (): JSX.Element => {
  const { profile, refresh } = useProfile();

  return (
    <PersonalInfoPageContent
      person={profile.person || undefined}
      onUpdateUser={refresh}
      toastSuccessText="Your personal information has been updated."
      isMyPersonalInfo
    />
  );
};

export default HomePersonalInfo;
